var locale = {
  // Options
  items_per_page: '/ páxina',
  jump_to: 'Ir a',
  jump_to_confirm: 'confirmar',
  page: '',
  // Pagination
  prev_page: 'Páxina anterior',
  next_page: 'Páxina seguinte',
  prev_5: '5 páxinas previas',
  next_5: '5 páxinas seguintes',
  prev_3: '3 páxinas previas',
  next_3: '3 páxinas seguintes',
  page_size: 'Page Size'
};
export default locale;